import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'libroVentasData';

export function useVentas() {
  const [ventas, setVentas] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Error leyendo ventas', e);
      return [];
    }
  });

  useEffect(() => {
    try {
      saveUtilityCache(STORAGE_KEY, ventas);
    } catch (e) {
      console.error('Error guardando ventas', e);
    }
  }, [ventas]);

  const agregarVenta = (data) => {
    setVentas(prev => [
      ...prev,
      {
        id: uuid(),
        ...data,
        estado: 'ACTIVA', // ACTIVA | ANULADA
        createdAt: new Date().toISOString(),
        updatedAt: null,
        motivoAnulacion: null
      }
    ]);
  };

  const editarVenta = (id, data) => {
    setVentas(prev =>
      prev.map(v =>
        v.id === id
          ? { ...v, ...data, updatedAt: new Date().toISOString() }
          : v
      )
    );
  };

  const anularVenta = async (id, motivo) => {
    setVentas(prev =>
      prev.map(v =>
        v.id === id
          ? {
              ...v,
              estado: 'ANULADA',
              motivoAnulacion: motivo,
              updatedAt: new Date().toISOString()
            }
          : v
      )
    );
  };

  return { ventas, agregarVenta, editarVenta, anularVenta };
}
